import React, { useState } from "react";
import { api, extractError } from "@/lib/api";
import { AlertOctagon, Loader2 } from "lucide-react";
import { toast } from "sonner";

/**
 * A big red SOS button that opens a confirm-and-send prompt.
 * Optionally scoped to a booking; if the browser has geolocation, the coords
 * are attached to the alert.
 */
export default function SOSButton({ bookingId = null, size = "md", testId = "sos-btn" }) {
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!window.confirm("Raise an SOS alert now? The family (or sitter) and platform admins will be notified.")) return;
    setBusy(true);
    let lat = null, lng = null;
    try {
      if ("geolocation" in navigator) {
        await new Promise((resolve) => {
          navigator.geolocation.getCurrentPosition(
            (pos) => { lat = pos.coords.latitude; lng = pos.coords.longitude; resolve(); },
            () => resolve(),
            { timeout: 4000 },
          );
        });
      }
      const msg = window.prompt("Optional message (what's happening?)", "") || "";
      await api.post("/emergency/sos", { booking_id: bookingId, message: msg, lat, lng });
      toast.success("SOS raised. Help is on the way.");
    } catch (e) { toast.error(extractError(e)); }
    finally { setBusy(false); }
  };

  const cls = size === "sm"
    ? "inline-flex items-center gap-1.5 rounded-full bg-danger text-white text-xs font-bold px-3 py-1.5 hover:bg-red-700 transition-colors duration-200"
    : "inline-flex items-center gap-2 rounded-full bg-danger text-white text-sm font-bold px-4 py-2 hover:bg-red-700 transition-colors duration-200";

  return (
    <button type="button" onClick={submit} disabled={busy} data-testid={testId} className={cls}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <AlertOctagon className="w-4 h-4" />}
      SOS
    </button>
  );
}
